<template>
    <div class="page bg-gray" style="padding-bottom: 2.44rem">
        <backTitleBar></backTitleBar>
        <div class="shop-top">
            <div class="shop-info">
                <div class="left-info">
                    <div class="name">{{entity.shopName}}(<span :class="stateCss">{{shopActState}}</span>)</div>
                    <div class="addr">{{entity.address}}</div>
                </div>
            </div>
            <div class="top-setting">
                <div class="setting-item bd-bot">
                    <div class="item-name"> 开门声音</div>
                    <div class="item-range">
                        <van-slider v-model="entity.doorVolumeNum" ar-height="4px" active-color="#83C221"
                                    @change="valueChange($event,1)"/>
                    </div>
                    <div class="item-rang-num">{{entity.doorVolumeNum}}</div>
                </div>
                <div class="setting-item bd-bot">
                    <div class="item-name"> 广告声音</div>
                    <div class="item-range">
                        <van-slider v-model="entity.advertVolumeNum" ar-height="4px" active-color="#83C221"
                                    @change="valueChange($event,2)"/>
                    </div>
                    <div class="item-rang-num">{{entity.advertVolumeNum}}</div>
                </div>
                <div class="setting-item bd-bot">
                    <div class="item-name"> 温度</div>
                    <div class="item-range">
                        <van-slider v-model="entity.temperature" :min="-20" :max="70" ar-height="4px"
                                    active-color="#83C221" @change="valueChange($event,3)"/>
                    </div>
                    <div class="item-rang-num">{{entity.temperature}}℃</div>
                </div>
                <div class="setting-item">
                    <div class="item-name"> 门锁状态</div>
                    <div class="item-value"></div>
                    <div class="item-right">{{entity.shopOffState == '0'?'释放':'锁住'}}</div>
                </div>
            </div>
        </div>
        <div class="card" style="margin-top: 2.2rem">
            <div class="setting-item click bd-bot"
                 @click="$router.push({ name:'equipmentSettingInfo',query:{shop:JSON.stringify(entity),type:'name'}})">
                <div class="item-name"> 名称</div>
                <div class="item-value">{{entity.shopName}}</div>
                <div class="item-right-icon alifont icon-fanhui1"></div>
            </div>
            <div class="setting-item click bd-bot" @click="$router.push({ name:'equipmentSettingInfo',query:{shop:JSON.stringify(entity),type:'address'}})">
                <div class="item-name"> 地址</div>
                <div class="item-value">{{areaName + entity.address}}</div>
                <div class="item-right-icon alifont icon-fanhui1"></div>
            </div>
            <div class="setting-item click bd-bot" @click="$router.push({ name:'equipmentSettingInfo',query:{shop:JSON.stringify(entity),type:'lnglat'}})">
                <div class="item-name"> 经纬度</div>
                <div class="item-value">{{entity.lng + '&nbsp;&nbsp;' + entity.lat}}</div>
                <div class="item-right-icon alifont icon-fanhui1"></div>
            </div>
            <div class="setting-item click" @click="$router.push({ name:'equipmentSettingInfo',query:{shop:JSON.stringify(entity),type:'sn'}})">
                <div class="item-name"> SN码</div>
                <div class="item-value">{{entity.deviceSn}}</div>
                <div class="item-right-icon alifont icon-fanhui1"></div>
            </div>

            <div class="setting-item click" @click="$router.push({ name:'equipmentSettingInfo',query:{shop:JSON.stringify(entity),type:'deviceVersionId'}})">
                <div class="item-name"> 设备版本</div>
                <div class="item-value">{{entity.deviceVersionName}}</div>
                <div class="item-right-icon alifont icon-fanhui1"></div>
            </div>

        </div>
<!--        <div class="item-btns" >-->
<!--            <div class="click btn" @click="updatePriceShow()">更新价签价格</div>-->
<!--        </div>-->


        <div class="btn-group" v-if="entity.equipmentType == 'weigh'">
            <div class="btn click" @click="updatePriceShow()">同步价签</div>
            <div class="btn click" @click="$router.push({name:'equipmentPeel',query:{shopId:shopId}})" style="margin-right: .3rem;">去皮设置</div>
            <div class="btn click" @click="reloadSys()">重启系统</div>
        </div>
        <div class="click run-btn" @click="reloadSys()" v-if="entity.equipmentType != 'weigh'">重启系统</div>

        <van-action-sheet v-model="actionShow" :actions="actions" @select="onSelect"/>
        <navs :shopId="shopId"></navs>
    </div>

</template>
<script>
    import navs from "./equipment-navs"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {
        qryShopDetail,
        saveShopInfo,
        restartShop,
        restartAdvert,
        queryShopZoneWayItemList,
        clearWeight,
        updateShopPriceShow,
        getShopDeviceVersion,
        getLastHeartbeat
    } from "@/api/shop"
    import {getToken,getAgentId} from '@/utils/util'
    export default {
        name: 'equipmentSetting',
        components: {navs,backTitleBar},
        computed: {
            'areaName': function () {
                if (this.entity.areaname) {
                    return this.entity.areaname.split(",").join("")
                } else {
                    return ''
                }

            }
        },
        data() {
            return {
                shopId: '',
                entity: {
                    deviceVersionName:''
                },
                stateCss:'',
                shopActState:'未知',
                actions: [
                    {name: '重启系统'},
                    {name: '通过广告App重启设备App'},
                    {name: '通过设备App重启设备App'},
                ],
                actionShow: false,
                curZone: {}
            }
        },
        created() {
            this.$store.state.showFooter = false;
            this.$store.state.shop_nav_value = 3;

            if (this.$route.query.shopId) {
                this.shopId = this.$route.query.shopId;
            }
            this.getDetail();
            this.loadDeviceHeart();
        },
        mounted() {
        },
        methods: {
            getDetail() {
                qryShopDetail(this.shopId).then(res => {
                    this.entity = res.data;
                    this.$store.state.shop_info = res.data;
                    this.getDeviceVersion();
                    // if (this.entity.equipmentType == 'weigh') {
                    //     this.getZoneItemList();
                    // }
                })
            },
            getDeviceVersion() {
                if(this.entity.deviceVersionId == null) {
                    return;
                }
                let that = this;
                getShopDeviceVersion({versionId:this.entity.deviceVersionId}).then(res => {
                    this.$set(that.entity, 'deviceVersionName', res.data.versionName)
                })
            },
            loadDeviceHeart() {
                getLastHeartbeat({shopId:this.shopId}).then(res => {
                    let flag = this.isWithinNextFiveMinutes(res.data.updateTime)
                    if(flag ){
                        this.shopActState = "在线"
                        this.stateCss = "online"
                    }else{
                        this.shopActState = "离线"
                        this.stateCss = "offline"
                    }

                })
            },
            isWithinNextFiveMinutes(targetTime) {
                const targetDate = new Date(targetTime);
                const now = new Date();
                const fiveMinutesInMs = 5 * 60 * 1000;

                // 计算时间差（目标时间 - 当前时间）
                const timeDiff = now.getTime() - targetDate.getTime() ;

                // 判断是否在未来5分钟内
                return timeDiff > 0 && timeDiff <= fiveMinutesInMs;
            },
            updatePriceShow(){
                let _this = this;
                let params = {
                    shopIds:this.entity.shopId
                }
                updateShopPriceShow(params).then(res => {
                    if (res.code == 0) {
                        _this.$toast("发送成功");
                    }else{
                        _this.$toast("发送失败，请重试!");
                    }
                })
            },
            valueChange(value, type) {
                let _this = this;
                let msg = '';
                let params = {
                    shopId: this.entity.shopId
                };
                switch (type) {
                    case 1:
                        msg = '开门声音确定修改为' + value + "?<br/>修改成功后，设备将在几分钟后生效！";
                        params.doorVolumeNum = value;
                        break;
                    case 2:
                        msg = '广告声音确定修改为' + value + "?<br/>修改成功后，设备将在几分钟后生效！";
                        params.advertVolumeNum = value;
                        break;
                    case 3:
                        msg = '温度确定修改为' + value + "℃?";
                        params.temperature = value;
                        break;
                }
                this.$dialog.alert({
                    title: "提示",
                    message: msg,
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        saveShopInfo(params).then(res => {
                            if (res.code == 0) {
                                _this.$toast("修改成功");
                                if (type == 1) {
                                    this.entity.doorVolumeNum = value;
                                } else if (type == 2) {
                                    this.entity.advertVolumeNum = value;
                                } else if (type == 3) {
                                    this.entity.temperature = value;
                                }
                            }
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        _this.entity.tempAdvertVolumeNum = _this.entity.oldTempAdvertVolumeNum;
                        _this.entity.tempDoorVolumeNum = _this.entity.oldTempDoorVolumeNum;
                        _this.entity.temperature = _this.entity.oldTemperature;
                    })
            },
            //重启系统
            reloadSys() {
                this.actionShow = true;
            },
            onSelect(item, index) {
                if (index == 0 || index == 1) {
                    let params = {
                        shopIds: this.entity.shopId,
                        reloadType: index
                    }
                    restartAdvert(params).then(res => {
                        if (res.code === 0) {
                            this.$toast("操作成功");
                            this.actionShow = false;
                        }
                    })
                } else if (index == 2) {
                    let params = {
                        shopIds: this.entity.shopId,
                    }
                    restartShop(params).then(res => {
                        if (res.code === 0) {
                            this.$toast("操作成功");
                            this.actionShow = false;
                        }
                    })
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    .page-flex {
        background: #F5F6FA;
        padding-bottom: 2.44rem;
    }

    .shop-top {
        background: rgb(60, 65, 90);
        padding-bottom: 2.5rem;
        padding-top: .5rem;
        position: relative;
    }

    .shop-header {
        display: flex;
        height: 1rem;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background: rgb(60, 65, 90);
        z-index: 10;
        .back {
            width: 1rem;
            height: 1rem;
            text-align: center;
            line-height: 1rem;
            .mintui-back {
                color: #fff;
            }
        }
        .header-title {
            font-size: .32rem;
            line-height: .45rem;
            flex: 1;
            text-align: center;
            color: #fff;
        }
        .header-icon {
            width: 1rem;
            height: 1rem;
            text-align: center;
            line-height: 1rem;
            font-size: .6rem;
            color: #fff;
        }
    }

    .shop-info {
        padding: 0 .5rem;
        display: flex;
        align-items: center;
        .right-time {
            padding: .2rem .25rem;
            border: .01rem solid #919BA6;
            text-align: center;
            border-radius: .25rem;
            margin-left: .2rem;
            color: #919BA6;
            font-size: .28rem;
        }
        .left-info {
            flex: 1;
            .name {
                font-size: .4rem;
                line-height: .56rem;
                color: #fff;
            }
            .addr {
                color: #919BA6;
                font-size: .28rem;
                line-height: .5rem;
                margin-top: .05rem;
            }
        }
    }

    .card {
        margin: 0 .25rem;
        background: #fff;
        border-radius: .24rem;
    }

    .top-setting {
        position: absolute;
        width: 7rem;
        bottom: -2rem;
        background: #fff;
        border-radius: .24rem;
        left: .25rem;
    }

    .setting-item {
        display: flex;
        padding: .28rem .32rem;
        align-items: center;
        .item-name {
            width: 1.8rem;
            font-size: .34rem;
            line-height: .48rem;
            color: #252D46;
        }
        .item-range {
            width: 3.3rem;
        }
        .item-rang-num {
            flex: 1;
            text-align: right;
            font-size: .32rem;
            line-height: .45rem;
            color: #919BA6;
        }
        .item-right {
            flex: 1;
            text-align: right;
            font-size: .32rem;
            line-height: .45rem;
            color: #919BA6;
        }
        .item-value {
            font-size: .32rem;
            line-height: .45rem;
            color: #919BA6;
            text-align: right;
            flex: 1;
        }
        .item-right-icon {
            font-size: .26rem;
            color: #919BA6;
            margin-left: .2rem;
        }
    }

    .run-btn {
        margin: .25rem;
        height: .94rem;
        line-height: .94rem;
        border-radius: .24rem;
        background: $main-color;
        border: none;
        text-align: center;
        color: #fff;
        font-size: .36rem;
    }

    .way-item {
        padding: .2rem .3rem;
        border-bottom: .01rem solid #eaeaea;
        display: flex;
        justify-content: space-between;
        background: #fff;
        .left {
            width: 2rem;
            text-align: center;
            line-height: .7rem;
            background: $main-color;
            border-radius: .1rem;
            color: #fff;
            font-size: .3rem;
        }
        .right {
            width: 2rem;
            text-align: center;
            height: .7rem;
            line-height: .68rem;
            border: .01rem solid $main-color;
            color: $main-color;
            font-size: .3rem;
            background: #fff;
            border-radius: .1rem;
        }
    }

    .btn-group {
        background: #fff;
        padding: .1rem .3rem;
        display: flex;
        position: fixed;
        bottom: 1.14rem;
        width: 100%;
        left: 0;
        .btn {
            flex: 1;
            height: .9rem;
            text-align: center;
            background: $main-color;
            border-radius: .1rem;
            color: #fff;
            font-size: .32rem;
            line-height: .9rem;
            &:first-child {
                margin-right: .3rem;
            }

        }
    }
    .item-btns {
        margin-top: .35rem;
        display: flex;
        margin-left: .2rem;
        margin-right: .2rem;
        .btn {
            flex: 1;
            background:#c8c9cc;
            border-radius: .24rem;
            height: .84rem;
            text-align: center;
            line-height: .84rem;
            color: #33415E;
            font-size: .3rem;
            &:nth-child(2) {
                margin-left: .2rem;
            }
        }
    }
    .online{
        color:green;
    }
    .offline{
        color:red
    }
    .pb-navs{
        padding-bottom: 1.34rem;
    }
</style>



// WEBPACK FOOTER //
// equipmentSetting.vue?4e3ce5a3